<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-primary)]">
    <template #left>
      <RouterLink
        class="bg-[var(--va-primary)] h-full flex flex-col items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <!-- make img and p different line -->
        <img src="/rushda_logo-white.png" alt="" width="400" />
        <p class="text-white px-10 text-center mt-5">
          Rushda Soft is a software development company in Dhaka, Bangladesh that specializes in providing Custom
          Software Solutions, Web Development, Mobile Apps, SEO Solutions, Domain, and Hosting for small to large
          businesses.
        </p>
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-primary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <img src="/rushda_logo-white.png" alt="" width="400" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui';

const breakpoint = useBreakpoint()
</script>
